import { PlanetType, PlanetTypeData, PlanetTypeGroup } from '@apeiron/planet'
import { createStrictContext } from '@apeiron/temp'
import useFetchPlanetTypeGroupJson from '@src/hooks/json/useFetchPlanetTypeGroupJson'
import React, { useMemo } from 'react'

const [ContextProvider, usePlanetTypeContext] =
  createStrictContext<PlanetTypeContextValue>('PlanetType')

export { usePlanetTypeContext }

export const PlanetTypeProvider: React.FC<Props> = props => {
  const { children } = props

  const { data: planetTypeGroupData } = useFetchPlanetTypeGroupJson()

  const planetTypeContextValue = useMemo<PlanetTypeContextValue>(() => {
    const groupData = planetTypeGroupData || []

    return {
      planetTypeGroupData: groupData,
      getPlanetTypeData(planetType: PlanetType) {
        return groupData
          .flatMap(group => group.planetTypes)
          .find(type => type.name === planetType)
      }
    }
  }, [planetTypeGroupData])

  return (
    <ContextProvider value={planetTypeContextValue}>{children}</ContextProvider>
  )
}

export type PlanetTypeContextValue = {
  planetTypeGroupData: PlanetTypeGroup[]
  getPlanetTypeData: (planetType: PlanetType) => PlanetTypeData | undefined
}

export type Props = {
  children: React.ReactNode
}
